<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import vClickOutside from "v-click-outside";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

import { Carousel, Slide } from "vue-carousel";
import { required } from "vuelidate/lib/validators";

import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  components: {
    Layout,
    PageHeader,
    FinanceTemplate: () =>
      import(/* webpackPrefetch: true */ "@/components/widgets/finance-templates"),
    FinanceWidgetTemplate: () =>
      import(/* webpackPrefetch: true */ "@/components/widgets/finance-template-widget"),
    // PrintOptions: () =>
    //   import(/* webpackPrefetch: true */ "@/components/modals/print-options"),
    Carousel,
    Slide,
    Multiselect,
    DatePicker,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  page: {
    title: "Finance Template",
  },
  data() {
    return {
      title: "Finance Template",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Finance Template",
          active: true,
        },
      ],
      fundSources: [],
      outcomes: [],
      processedOutcomes: [],
      fsSelection: false,
      openFS: false,
      selectedFS: null,
      filterFS: "",
      templates: [],
      templatesModal: [],
      cycleOption: [2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030],
      record: {
        id: 0,
        title: "",
        fundSourceId: null,
        cycle: Number(this.$store.state.data.cycle),
        isPrePlanning: false,
        fundExpiry: Date.parse(
          new Date(Number(this.$store.getters["data/getCycle"]), 11, 31)
        ),
      },
      importData: {
        financeTemplateId: null,
        fundSourceId: null,
        cycle: this.$store.state.data.cycle,
      },

      importFundSource: [],
      fundSourcesForModal: [],
      templateModal: {
        show: false,
        title: "",
      },
      submitted: false,
      selectedTemplate: null,
      setupLoader: false,
      sidebar: true,
      importModal: false,
      campusAccessList: [],
      selectedFundSource: null,
      selectedCampus: null,
      selectedFundSourceForModal: null,
      selectedCycleForModal: null,
    };
  },
  computed: {
    filteredFS() {
      let data = this.fundSources;
      if (this.filterFS.trim() != "" && this.filterFS) {
        data = data.filter((item) => {
          return item.sourceName.toUpperCase().includes(this.filterFS.toUpperCase());
        });
      }
      return data;
    },
  },

  methods: {
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    async fetchFS() {
      await this.$store
        .dispatch("fundsource/GetFundSource")
        .then((response) => {
          this.fundSources = response.data.filter(
            (item) => (item.hasExpiry && this.checkExpiry(item.expiry)) || !item.hasExpiry
          );
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch fund sources. Please contact administrator",
            "error"
          );
        });
    },
    fetchTemplates(id) {
      this.$store
        .dispatch("financeTemplate/getPreplanning", { fundSourceId: id, cycle: this.$store.state.data.cycle })
        .then((response) => {
          this.templates = response.data;
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch finance templates. Please contact administrator",
            "error"
          );
        });
    },
    openFSSelection() {
      this.fsSelection = true;
      this.openFS = true;
    },
    closeFS() {
      if (this.fsSelection) {
        this.fsSelection = false;
      }
      this.openFS = false;
    },
    getFundSources(data) {
      this.$store
        .dispatch("fundsource/GetFundSourcesByCampusId", data)
        .then((response) => {
          this.fundSources = this.fundSources = response.data.filter(
            (item) => (item.hasExpiry && this.checkExpiry(item.expiry)) || !item.hasExpiry
          );
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch fund sources. Please contact administrator",
            "error"
          );
        });
    },
    getFundSourcesForModal(id) {
      this.$store
        .dispatch("fundsource/GetFundSourcesByCampusId", id)
        .then((response) => {
          this.fundSourcesForModal = this.fundSourcesForModal = response.data.filter(
            (item) => (item.hasExpiry && this.checkExpiry(item.expiry)) || !item.hasExpiry
          );
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch fund sources. Please contact administrator",
            "error"
          );
        });
    },
    selectFS(row) {
      this.fsSelection = false;
      this.selectedFS = row;
      this.title = `Finance Template for ${row.sourceName}`;
      this.importData.fundSourceId = row.id;
      this.importFundSource = [];
      this.importFundSource = this.fundSources.filter((item) => {
        return item.id !== row.id;
      });
      /** Fetch fund source templates */
      this.fetchTemplates(this.selectedFS.id);
      setTimeout(() => {
        this.sidebar = false;
      }, 500);
    },
    createTemplate() {
      if (!this.selectedFS) {
        this.showToast("Please select fund source", "error");
        return;
      }
      this.templateModal.title = "Create New Template";
      this.templateModal.show = true;
    },
    hideModal() {
      this.templateModal.show = false;
    },
    resetData() {
      this.record = {
        id: 0,
        title: "",
        fundSourceId: null,
        cycle: Number(this.$store.state.data.cycle),
      };
      this.submitted = false;
    },
    selectFSTemplate(row) {
      this.importData.financeTemplateId = row.id;
    },
    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.record.$invalid) {
        return;
      } else {
        let nData = JSON.parse(JSON.stringify(this.record));
        nData.fundExpiry = this.formatDateToISO(this.record.fundExpiry);
        if (this.record.id > 0) {
          this.$store
            .dispatch("financeTemplate/updateFinanceTemplate", {
              id: this.record.id,
              data: nData,
            })
            .then(() => {
              this.fetchTemplates(this.record.fundSourceId);
              this.hideModal();
              this.resetData();
              this.showToast("Finance template updated successfully", "success");
            })
            .catch(() => {
              this.showToast(
                "Failed to update finance template. Please contact administrator",
                "error"
              );
            });
        } else {
          // this.record.fundSourceId = this.selectedFS.id;
          nData.fundSourceId = this.selectedFS.id;
          this.$store
            .dispatch("financeTemplate/createFinanceTemplate", nData)
            .then((response) => {
              this.fetchTemplates(this.selectedFS.id);
              this.hideModal();
              this.resetData();
              this.showToast("Finance template created successfully", "success");
            })
            .catch(() => {
              this.showToast(
                "Failed to create finance template. Please contact administrator",
                "error"
              );
            });
        }
      }
    },
    editTemplate(record) {
      this.record = {
        id: record.id,
        title: record.title,
        fundSourceId: record.fundSourceId,
        cycle: record.cycle,
        fundExpiry: Date.parse(new Date(record.fundExpiry)),
      };
      this.templateModal.title = "Edit Template";
      this.templateModal.show = true;
    },
    deleteTemplate(record) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("financeTemplate/deleteFinanceTemplate", record.id)
            .then(() => {
              this.fetchTemplates(this.selectedFS.id);
              this.showToast("Finance template deleted successfully", "success");
            })
            .catch(() => {
              this.showToast(
                "Failed to delete finance template. Please contact administrator",
                "error"
              );
            });
        }
      });
    },
    viewTemplate(record) {
      this.$refs.financeWidgetTemplate.startToZero();
      if (!this.oldSelectedTemplate) {
        this.oldSelectedTemplate = record;
        this.selectedTemplate = record;
        this.loadOutcomes();
      } else {
        if (this.oldSelectedTemplate.id !== record.id) {
          this.oldSelectedTemplate = record;
          this.selectedTemplate = record;
          this.loadOutcomes();
        } else {
          this.$refs.carousel.goToPage(1);
        }
      }
    },
    loadOutcomes() {
      this.setupLoader = true;

      this.outcomes = [];
      this.$store
        .dispatch("outcome/GetOutcome")
        .then((response) => {
          this.outcomes = response.data.map((item) => ({
            ...item,
            rotateChevy: false,
            showDetails: false,
            prexcs: [],
          }));
          this.setupLoader = false;
          this.$refs.carousel.goToPage(1);
        })
        .catch(() => {
          this.setupLoader = false;
          this.showToast(
            "Failed to fetch outcomes. Please contact administrator",
            "error"
          );
          return false;
        });
    },

    backTemplate() {
      this.$refs.carousel.goToPage(0);
    },
    switchFS() {
      this.sidebar = !this.sidebar;
      this.backTemplate();
    },
    send() {
      this.$swal({
        title: "Warning!",
        html: `<span>Activating this template may cause errors if not configured properly. Make sure to check settings before activating. You won't be able to revert this!</span><hr /><div class="mt-1 text-start"><p class="mb-0"><span>Total: </span><strong class="text-info">${this.formatCurrency(
          this.selectedTemplate.total
        )}</strong></p><p><span>Cycle: </span><strong class="text-info">${
          this.selectedTemplate.cycle
        }</strong></p></div><hr />`,
        icon: "warning",
        input: "text",
        inputLabel: "Enter cycle to confirm:",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Activate",
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
          if (Number(value) !== this.selectedTemplate.cycle) {
            return "Cycle does not match! Please try again";
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("financeTemplate/sendTemplate", this.selectedTemplate.id)
            .then((response) => {
              if (response.data.error) {
                this.showToast(response.data.errorMessage, "error");
                return;
              }
              this.showToast("Finance template activated successfully", "success");
            })
            .catch(() => {
              this.showToast(
                "Failed to activate finance template. Please contact administrator",
                "error"
              );
            });
        }
      });
    },
    importTemplate(data) {
      if (!this.importData.fundSourceId || !this.importData.financeTemplateId) {
        this.showToast("Please select fund source and template", "error");
        return;
      }
      let nData = {};
      nData.fundSourceId = this.importData.fundSourceId;
      nData.financeTemplateId = this.importData.financeTemplateId;
      nData.cycle = Number(this.$store.getters["data/getCycle"]);
      nData.isActualDestination = data;
      this.$store
        .dispatch("financeTemplate/importTemplate", nData)
        .then(() => {
          this.fetchTemplates(this.selectedFS.id);
          this.importData = {
            fundSourceId: null,
            financeTemplateId: null,
          };
          this.importModal = false;
          this.showToast("Finance template imported successfully", "success");
        })
        .catch((error) => {
          this.showToast(
            "Failed to import finance template. Please contact administrator",
            "error"
          );
        });
    },
    updateTemplate(id) {
      this.$store
        .dispatch("financeTemplate/getSingleTemplate", id)
        .then((response) => {
          this.selectedTemplate = response.data;
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch Pre-planning. Please contact administrator",
            "error"
          );
        });
    },
    processImportModal() {
      if (!this.selectedFS) {
        this.showToast("Please select fund source", "error");
        return;
      }
      this.importModal = true;
      this.fundSourcesForModal = this.fundSources;
      //   this.getFundSourcesForModal(this.selectedCampus.code);
    },
    fetchTemplatesModal() {
      if (!this.selectedCycleForModal || !this.selectedFundSourceForModal) {
        this.showToast("Please select all fields", "error");
        return;
      }
      this.$store
        .dispatch("financeTemplate/getPreplanning", {
          fundSourceId: this.selectedFundSourceForModal.id,
          cycle: this.selectedCycleForModal,
        })
        .then((response) => {
          this.templatesModal = response.data;
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch Pre-planning. Please contact administrator",
            "error"
          );
        });
    },
    changeCampus(data) {
      this.selectedCampus = data.id;
      this.getFundSources(this.selectedCampus, "sidebar");
      this.getFundSources(this.selectedCampus, "modal");
      this.templates = [];
      this.selectedFundSource = null;
      this.searchedData = {
        fundSourceId: null,
        cycle: this.$store.state.data.cycle,
      };
      this.searchedDataModal = {
        fundSourceId: null,
        cycle: this.$store.state.data.cycle,
      };
    },
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
    // await this.fetchFS();
    // this.campusAccessList = this.$store.state.decrypt.campusAccessList().map((item) => ({
    //   code: item.Id,
    //   label: item.CampusName,
    // }));
  },
  validations: {
    record: {
      title: { required },
      fundExpiry: { required },
    },
  },
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <div class="d-md-flex flex-wrap">
      <div class="me-md-auto mb-2">
        <b-button @click="switchFS" variant="outline-primary" class="btn-block">
          <i class="mdi mdi-file-compare align-middle me-2 font-size-13"></i>
          View Fund Sources
        </b-button>
      </div>
      <!-- <div class="me-md-2">
        <b-button
          variant="outline-success"
          class="me-2 btn-block mb-2"
          @click="processImportModal"
        >
          <i class="mdi mdi-database-import-outline align-middle me-2 font-size-14"></i>
          Import Pre-planning
        </b-button>
      </div> -->
      <div>
        <b-button variant="primary" @click="createTemplate" class="btn-block">
          <i class="bx bx-list-check align-middle me-2 font-size-18"></i>
          Create Template
        </b-button>
      </div>
    </div>
    <b-sidebar
      v-model="sidebar"
      width="30em"
      title="Fund Sources"
      bg-variant="dark"
      text-variant="light"
      shadow
      no-header
      backdrop
    >
      <template>
        <!-- <div class="p-3">
          <h5 class="card-title mb-3">Campus</h5>
          <multiselect
            v-model="selectedCampus"
            placeholder="Select campus..."
            :options="campusAccessList"
            :searchable="true"
            :close-on-select="true"
            track-by="code"
            label="label"
            @input="getFundSources"
          >
          </multiselect>
        </div> -->
        <div class="p-3">
          <h5 class="card-title mb-3">Fund Sources</h5>
          <multiselect
            v-model="selectedFundSource"
            placeholder="Select fund source..."
            :options="fundSources"
            :searchable="true"
            :close-on-select="true"
            track-by="id"
            label="sourceName"
            @input="selectFS"
          >
          </multiselect>
        </div>
      </template>
    </b-sidebar>
    <div class="row mt-3">
      <div class="col-md-12 mt-3 mt-md-0">
        <carousel
          ref="carousel"
          class="events navs-carousel"
          :navigation-enabled="false"
          :pagination-enabled="false"
          :perPage="1"
          :autoplay="false"
          :minSwipeDistance="0"
          :mouseDrag="false"
        >
          <slide>
            <FinanceTemplate
              :templates="templates"
              :fundSources="fundSources"
              v-if="templates.length > 0"
              @edit="editTemplate"
              @delete="deleteTemplate"
              @view="viewTemplate"
            />
            <div v-if="templates.length === 0">
              <div class="alert alert-warning alert-dismissible fade show">
                <i class="bx bx-info-circle me-2"></i>
                No records found. Make sure you have selected a fund source or at least
                create one (1) template for fund source.
              </div>
            </div>
          </slide>

          <slide class="custom-table-responsive">
            <div class="row mb-3">
              <b-col sm="6">
                <div class="d-flex align-items-center">
                  <a href="javascript:void(0);" class="me-1" @click="backTemplate"
                    ><i class="bx bx-left-arrow-alt fs-2"></i
                  ></a>
                  <div>
                    <h4 class="m-0">Back to Overview</h4>
                  </div>
                </div>
              </b-col>
              <b-col sm="6" class="text-end">
                <b-button variant="success" class="me-3" size="sm" @click="send">
                  <i class="mdi mdi-animation-outline font-size-15 me-2 align-middle"></i>
                  Activate Template
                </b-button>
              </b-col>
            </div>

            <p class="mb-0">
              <span>Template: </span
              ><span class="text-info">{{
                this.selectedTemplate ? this.selectedTemplate.title : ""
              }}</span>
            </p>
            <p class="mb-0">
              <span>Fund Source: </span
              ><span class="text-info">{{
                this.selectedTemplate ? this.selectedTemplate.fundSource.sourceName : ""
              }}</span>
            </p>
            <p class="mb-0">
              <span>Cycle: </span
              ><span class="badge rounded-pill bg-info">{{
                this.selectedTemplate ? this.selectedTemplate.cycle : 0
              }}</span>
            </p>
            <p class="mb-0">
              <span>Total: </span
              ><span class="text-warning">{{
                this.selectedTemplate
                  ? formatCurrency(this.selectedTemplate.total)
                  : formatCurrency(0)
              }}</span>
            </p>
            <p>
              <small class="text-warning"
                >NOTE! Make sure to add Object of Expenditures before adding it to
                Delivery units (2nd tab).</small
              >
            </p>
            <!-- Load all outcomes -->
            <!-- <b-overlay :show="setupLoader" variant="dark" opacity="0.85"> -->
            <FinanceWidgetTemplate
              ref="financeWidgetTemplate"
              :outcomes="outcomes"
              :template="selectedTemplate ? selectedTemplate.id : null"
              v-if="outcomes"
              @updateTemplate="updateTemplate"
            />
            <!-- </b-overlay> -->
          </slide>
        </carousel>
      </div>
    </div>
    <!-- Modals here -->
    <b-modal v-model="templateModal.show" :title="templateModal.title" hide-footer>
      <div class="mb-3 font-size-18" v-if="selectedFS">
        <strong>Fund Source: </strong
        ><span class="text-info">{{ selectedFS.sourceName }}</span>
      </div>
      <hr />
      <div class="mb-3">
        <label>Title</label>
        <b-input
          v-model="record.title"
          :class="{
            'is-invalid': submitted && $v.record.title.$error,
          }"
        ></b-input>
        <div v-if="submitted && $v.record.title.$error" class="invalid-feedback">
          <span v-if="!$v.record.title.required">This value is required.</span>
        </div>
      </div>
      <div class="mb-3">
        <label>Cycle</label>
        <b-form-select
          class="form-select"
          v-model="record.cycle"
          :options="cycleOption"
        ></b-form-select>
      </div>
      <div class="mb-3">
        <label>Fund Validity</label>
        <date-picker
          v-model="record.fundExpiry"
          :first-day-of-week="1"
          lang="en"
          value-type="timestamp"
          format="YYYY-MM-DD"
          :class="{
            'is-invalid': submitted && $v.record.fundExpiry.$error,
          }"
        ></date-picker>
        <div v-if="submitted && $v.record.fundExpiry.$error" class="invalid-feedback">
          <span v-if="!$v.record.fundExpiry.required">This value is required.</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="onSubmit">Save changes</button>
        <button type="button" class="btn btn-link" @click="hideModal">Close</button>
      </div>
    </b-modal>
    <!-- End modals here -->

    <!-- Import Modal here -->
    <b-modal
      v-if="selectedFS"
      v-model="importModal"
      size="xl"
      hide-footer
      :title="`Import Template To ${selectedFS.sourceName}`"
    >
      <div class="row">
        <div class="col-md-4">
          <b-card>
            <b-card-text>
              <b-form-group label="Fund source">
                <multiselect
                  v-model="selectedFundSourceForModal"
                  track-by="id"
                  label="sourceName"
                  placeholder="Select fund source..."
                  :options="fundSourcesForModal"
                  :searchable="true"
                  :close-on-select="true"
                >
                </multiselect>
              </b-form-group>
              <b-form-group label="Cycle">
                <multiselect
                  v-model="selectedCycleForModal"
                  placeholder="Select Cycle..."
                  :options="cycleOption"
                  :close-on-select="true"
                >
                </multiselect>
              </b-form-group>
              <b-button
                block
                class="mt-4"
                variant="primary"
                size="sm"
                @click="fetchTemplatesModal"
                >View Templates</b-button
              >
            </b-card-text>
          </b-card>
        </div>
        <div class="col-md-8">
          <h4 class="card-title my-3">Templates:</h4>
          <p class="text-info" v-if="templatesModal.length === 0">
            No templates to be shown...
          </p>
          <div class="row">
            <div class="col-md-4" v-for="template in templatesModal" :key="template.id">
              <label class="w-100">
                <input
                  type="radio"
                  name="template"
                  class="card-input-element"
                  @click="selectFSTemplate(template)"
                />
                <div class="card task-box card-input" id="uptask-1">
                  <div class="card-body">
                    <div>
                      <h5
                        class="font-size-13 mb-0 text-truncate w-75"
                        :id="`title-${template.id}`"
                      >
                        <a href="javascript: void(0);" class="text-dark">{{
                          template.title
                        }}</a>
                      </h5>
                      <p class="my-0">
                        <span>{{ template.fundSource.sourceName }}</span>
                      </p>
                      <p class="text-muted mb-4 mt-0">
                        <span class="badge rounded-pill bg-info">{{
                          template.cycle
                        }}</span>
                      </p>
                    </div>

                    <div class="text-start">
                      <h5 class="font-size-14 mb-0 text-warning">
                        {{ formatCurrency(template.total) }}
                      </h5>
                      <p class="mb-0 text-muted font-size-11">Budget</p>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <b-button size="sm" variant="success" class="me-2" @click="importTemplate(true)">
          <i class="mdi mdi-database-import-outline align-middle me-2 font-size-14"></i>
          Import
        </b-button>
      </div>
    </b-modal>
    <!-- Import Modal here -->
  </Layout>
</template>
<style>
/* .VueCarousel-slide-active {
  overflow-x: scroll;
} */
</style>
